import { BUYING_TEAMS_TOTAL_ALLOWED } from '@aibees/elephant/feature/buying-team-matrix/constants';
import { useBrowseBuyingTeamsApi } from '@aibees/elephant/feature/buying-team-matrix/hooks/use-browse-buying-teams-api';
import { Icon, IconButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { LoadingButton } from '@mui/lab';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useBuyingTeamDialogsContext } from '../../../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { BuyingTeamSettingsDialogHeaderProps as Props } from './types';

export const BuyingTeamSettingsDialogHeader = memo(
  ({ className, isHeaderSearch }: Props) => {
    const { createDialogState, settingsDialogState } =
      useBuyingTeamDialogsContext();
    const { matrixBrowseApi } = useBrowseBuyingTeamsApi();

    const handleClose = () => {
      settingsDialogState?.onFalse();
    };

    const handleNewPersona = () => {
      createDialogState?.onTrue();
      settingsDialogState?.onFalse();
    };

    if (isHeaderSearch) {
      return (
        <>
          <Stack flexDirection="column" gap={1}>
            <Stack flexDirection="row" gap={1}>
              <Typography variant="body2">Buying Team Managements</Typography>
              <Styled.Paper>
                <Typography variant="body2">
                  {matrixBrowseApi.data?.totalElements} /{' '}
                  {BUYING_TEAMS_TOTAL_ALLOWED} in use
                </Typography>
              </Styled.Paper>
            </Stack>

            <Typography variant="body2" sx={SX.headerSubtitle}>
              With Personas you can define different groups of people to target
              within key accounts.
            </Typography>
          </Stack>

          <Stack flexDirection="row" gap={1}>
            <LoadingButton
              variant="contained"
              color="primary"
              sx={SX.createBtn}
              onClick={handleNewPersona}
            >
              <Typography variant="body3">New Buying Team</Typography>
            </LoadingButton>
          </Stack>
        </>
      );
    }

    return (
      <Styled.Wrapper
        className={classnames('BuyingTeamSettingsDialogHeader', className)}
        sx={SX.root}
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack flexDirection="column" gap={1}>
          <Stack flexDirection="row" gap={1}>
            <Typography variant="body2">Buying Team Managements</Typography>

            <Styled.Paper>
              <Typography variant="body2">
                {matrixBrowseApi.data?.totalElements} /{' '}
                {BUYING_TEAMS_TOTAL_ALLOWED} in use
              </Typography>
            </Styled.Paper>
          </Stack>

          <Typography variant="body2" sx={SX.headerSubtitle}>
            With Personas you can define different groups of people to target
            within key accounts.
          </Typography>
        </Stack>
        <Stack flexDirection="row" gap={1}>
          <LoadingButton
            variant="contained"
            color="primary"
            sx={SX.createBtn}
            onClick={handleNewPersona}
          >
            <Typography variant="body3">New Buying Team</Typography>
          </LoadingButton>
          <IconButton
            icon={<Icon name="close" size={24} />}
            onClick={handleClose}
          />
        </Stack>
      </Styled.Wrapper>
    );
  }
);

BuyingTeamSettingsDialogHeader.displayName = 'BuyingTeamSettingsDialogHeader';
